import { render } from "./OtpConfirmPage.vue?vue&type=template&id=2c8f3641&scoped=true"
import script from "./OtpConfirmPage.vue?vue&type=script&lang=js"
export * from "./OtpConfirmPage.vue?vue&type=script&lang=js"

import "./OtpConfirmPage.vue?vue&type=style&index=0&id=2c8f3641&scoped=true&lang=css"

import exportComponent from "/Users/afolabitope/Documents/apps/redge/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c8f3641"]])

export default __exports__